import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-users-registration',
  templateUrl: './users-registration.component.html',
  styleUrls: ['./users-registration.component.scss']
})
export class UsersRegistrationComponent implements OnInit {
  users;
  showSpinner;
  elementSelected;ConfirmationService
  constructor(private userService: UserService) { }


  ngOnInit(): void {
    this.showSpinner = true;
    this.allStudentsRequestForInscription();
  }

  public allStudentsRequestForInscription(){
    this.userService.getUsers().subscribe(data => {
      this.users = data;
      this.showSpinner = false;
    })
  }

}
